import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AppConfigSettings, CoreService } from '@arc/arc-shared-frontend';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { CheckoutResolversActions } from './checkout-resolvers.actions';

export const paymentLinksCheckoutResolver: ResolveFn<object> = () => {
  const appSettings = inject(AppConfigSettings);
  const coreService = inject(CoreService);
  const store = inject(Store);
  const currentPersona = coreService.getPersonaIdFromLocalStorage();
  const isPaymentLinksPayor = currentPersona === 'btpay-paymentlinks-payor';
  const usePaymentLinksSettings = isPaymentLinksPayor ? 'true' : 'false';

  appSettings.setconfig('usePaymentLinkEndpoints', usePaymentLinksSettings);
  appSettings.setconfig('useHostedPaymentsPageEndpoints', 'false');
  appSettings.setconfig('disableSavePaymentAccount', usePaymentLinksSettings);
  appSettings.setconfig('disablePaymentDate', usePaymentLinksSettings);
  appSettings.setconfig('navigateOnStepChange', 'false');
  store.dispatch(
    CheckoutResolversActions.paymentLinksCheckoutResolved({
      disablePaymentDate: isPaymentLinksPayor,
    }),
  );
  return of({});
};
